import { overviewBundle } from "@/routes/apt/[apt_code]/overivew/overview-const"

export const headerBundle = {
  label: { ko: "운영 세대", en: "Active Households", es: "Hogares activos" },
  unit: { ko: "세대", en: "households", es: "hogares" },
  caption: {
    ko: "운영 세대 현황",
    en: "Active Households Overview",
    es: "Resumen de hogares activos"
  },
  tabs: overviewBundle.tabs,
  mobileSelect: {
    ko: "분석 기간 선택",
    en: "Select Analysis Period",
    es: "Seleccionar periodo de análisis"
  },
  select: {
    dong: { ko: "동 선택", en: "Select Building" },
    ho: { ko: "호 선택", en: "Select Unit" }
  },
  search: { ko: "검색", en: "Search" }
}
